import React from "react";
import {
  Box,
  Container,
  Link,
  AppBar as MuiAppBar,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { AppBar } from "../AppBar";
import { ArrowRight } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 60,
  },
  secondaryAppBar: {
    marginTop: 50,
    height: 50,
  },
  title: {
    marginTop: 10,
  },
  content: {
    marginTop: 110,
    paddingTop: 30,
    paddingBottom: 30,
  },
  error: {
    margin: 15,
    whiteSpace: "pre-wrap",
    overflowX: "hidden",
  },
}));

export const ErrorLayout: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <>
      <AppBar toolbarItems={[]} handleDrawerToggle={() => {}} />
      <MuiAppBar
        color="secondary"
        className={classes.secondaryAppBar}
      ></MuiAppBar>

      <Container maxWidth="lg" className={classes.root}>
        <div className={classes.content}>
          <div className={classes.error}>{children}</div>
        </div>
      </Container>
    </>
  );
};
